let pendingFile: File | null = null;

export const setPendingResume = (file: File) => { pendingFile = file; };
export const getPendingResume = (): File | null => pendingFile;
export const clearPendingResume = () => { pendingFile = null; };
